export class AllTextReport {
    heading: string;
    content: string;
}

export enum ReportTextPosition {
    Top,
    Right
}
